const TYPE = {
    ROUND : 'round',
    RECT : 'rect',
    ECLLIPSE : "ellipse",
    TRIANGLE : "triangle",
    OCTAGON : "octa",
    HEX : "exa",
    IMAGE : "image",
    ROUNDRECT : "roundRect"
}

export default TYPE;